import { useState, useEffect } from 'react';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { supabase } from '../supabase';

export const useFeedUser = () => {
  const [feedUser, setFeedUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [needsUsername, setNeedsUsername] = useState(false);

  useEffect(() => {
    const firebaseUser = auth.currentUser;
    if (!firebaseUser) { setLoading(false); return; }

    syncUser(firebaseUser);
  }, []);

  const syncUser = async (firebaseUser) => {
    try {
      // Check if user exists in Supabase
      const { data, error } = await supabase
        .from('feed_users')
        .select('*')
        .eq('id', firebaseUser.uid)
        .single();

      if (error && error.code === 'PGRST116') {
        // User doesn't exist in feed yet — get their Firebase display name
        const docRef = doc(db, 'users', firebaseUser.uid);
        const docSnap = await getDoc(docRef);
        const firebaseData = docSnap.data();

        // Use name from profile setup if available
        const suggestedName = firebaseData?.basicInfo?.name || 
                              firebaseData?.displayName || 
                              firebaseUser.email?.split('@')[0] || '';

        setNeedsUsername(true);
        setFeedUser({ 
          id: firebaseUser.uid, 
          username: suggestedName,
          isNew: true 
        });
      } else if (data) {
        setFeedUser(data);
        setNeedsUsername(false);
      }
    } catch (e) {
      console.error('Feed user sync error:', e);
    } finally {
      setLoading(false);
    }
  };

  const registerUsername = async (username, interests = []) => {
    const firebaseUser = auth.currentUser;
    if (!firebaseUser) return { error: 'Not authenticated' };

    // Check uniqueness
    const { data: existing } = await supabase
      .from('feed_users')
      .select('id')
      .eq('username', username)
      .single();

    if (existing) return { error: 'Username already taken' };

    const { data, error } = await supabase
      .from('feed_users')
      .insert({
        id: firebaseUser.uid,
        username,
        interests,
      })
      .select()
      .single();

    if (!error) {
      setFeedUser(data);
      setNeedsUsername(false);
    }
    return { data, error };
  };

  const updateProfile = async (updates) => {
    const { data, error } = await supabase
      .from('feed_users')
      .update(updates)
      .eq('id', feedUser.id)
      .select()
      .single();
    if (!error) setFeedUser(data);
    return { data, error };
  };

  return { feedUser, loading, needsUsername, registerUsername, updateProfile, setFeedUser };
};